import React from "react";
import Lottie from "react-lottie-wrapper";
import cn from "classnames";
import animationData from "./lottie-loader.json";
import classes from "./style.scss";

const spinnerOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Loader = ({
  isLoading,
  children,
  imageSrc,
  className,
  dimensions = {},
}) => {
  if (isLoading) {
    return imageSrc ? (
      <img src={imageSrc} alt="GCX loading logo" />
    ) : (
      <div>
        <Lottie
          options={spinnerOptions}
          height={dimensions.height || 200}
          width={dimensions.width || 200}
        />
      </div>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default Loader;
